<mat-dialog-actions class="justify-content-between">
    <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.BED' | translate }}</h3>
    <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.BED' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="bedForm">
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.ROOM_NUMBER' | translate }}</mat-label>
                    <mat-select formControlName="roomId">
                        <mat-option *ngFor="let roomNumber of roomNumberddl" [value]="roomNumber.id">
                            {{ roomNumber.name }}
                        </mat-option>

                    </mat-select>
                    <mat-error *ngIf="bedForm.get('roomId')?.hasError('required')">
                        {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row m-t-10">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.BED_NUMBER' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.BED_NUMBER' | translate }}" formControlName="bedNumber">
                    <mat-error *ngIf="bedForm.get('bedNumber')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="bedForm.get('bedNumber')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM5' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row m-t-10">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.STATUS' | translate }}</mat-label>
                    <mat-select formControlName="status">
                        <mat-option *ngFor="let status of roomstatusList" [value]="status">
                            {{ roomStatusData[status] }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-label><strong>{{'LABEL.IS_ACTIVE' | translate }}:</strong></mat-label>
                 &nbsp;&nbsp;&nbsp;&nbsp;
                <mat-checkbox class="example-margin" color="primary" formControlName="isActive"></mat-checkbox>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4 p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onUpdateBed()" *ngIf="isEdit"
                [disabled]="bedForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onAddBed()" *ngIf="!isEdit"
                [disabled]="bedForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>